import { Component, Input } from '@angular/core';
import { Equipo } from '@domain/equipo';
import { EstatusRetosEquipo } from '@domain/estatus.reto.equipo';

@Component({
  selector: 'proximo-reto',
  templateUrl: 'proximo-reto.html'
})
export class ProximoRetoComponent {

  @Input('equipo') equipo: Equipo;
  @Input('estatus') estatus: EstatusRetosEquipo;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/proximo-reto/proximo-reto.ts